import { render, staticRenderFns } from "./BasicPageLeft.vue?vue&type=template&id=57ba1d8d&scoped=true"
import script from "./BasicPageLeft.vue?vue&type=script&lang=js"
export * from "./BasicPageLeft.vue?vue&type=script&lang=js"
import style0 from "./BasicPageLeft.vue?vue&type=style&index=0&id=57ba1d8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba1d8d",
  null
  
)

export default component.exports